"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadeInWhenVisible = exports.Flexbox = exports.CenterComponent = exports.greenColor = exports.goldColor = void 0;
var React = require("react");
var framer_motion_1 = require("framer-motion/dist/framer-motion");
exports.goldColor = 'rgb(193, 135, 6)';
exports.greenColor = '#085610'; //'rgba(8, 86, 16, 0.5)'
var CenterComponent = /** @class */ (function (_super) {
    __extends(CenterComponent, _super);
    function CenterComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CenterComponent.prototype.render = function () {
        var style = {
            width: this.props.width ? this.props.width : '100%',
            height: this.props.height ? this.props.height : '100%',
            display: 'flex',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        };
        return (React.createElement("div", { style: style }, this.props.children));
    };
    return CenterComponent;
}(React.Component));
exports.CenterComponent = CenterComponent;
var Flexbox = /** @class */ (function (_super) {
    __extends(Flexbox, _super);
    function Flexbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Flexbox.prototype.render = function () {
        var style = __assign(__assign({}, this.props.styles), { display: 'flex', flexDirection: this.props.flexDirection ? this.props.flexDirection : 'column', flexWrap: this.props.flexWrap ? this.props.flexWrap : 'wrap', alignContent: this.props.alignContent ? this.props.alignContent : 'center', alignItems: this.props.alignItems ? this.props.alignItems : 'center', justifyContent: this.props.justifyContent ? this.props.justifyContent : 'center', rowGap: this.props.rowGap ? this.props.rowGap : 0, columnGap: this.props.columnGap ? this.props.columnGap : 20 });
        return (React.createElement("div", { style: style }, this.props.children));
    };
    return Flexbox;
}(React.Component));
exports.Flexbox = Flexbox;
var FadeInWhenVisible = function (_a) {
    var children = _a.children;
    return (React.createElement(framer_motion_1.motion.div, { initial: "hidden", whileInView: "visible", viewport: { once: true }, transition: { duration: 1.5 }, variants: {
            visible: { opacity: 1 },
            hidden: { opacity: 0 }
        } }, children));
};
exports.FadeInWhenVisible = FadeInWhenVisible;
//# sourceMappingURL=StyleComponents.js.map